import React from 'react';
import { useLearningMode } from '../../contexts/LearningModeContext';

/** Kapcsoló a tanuló módhoz - a Súgó oldalon és a mobil menüben. */
const LearningModeSwitch: React.FC<{ label?: string }> = ({ label = 'Tanuló mód' }) => {
  const { enabled, toggle } = useLearningMode();

  return (
    <button
      type="button"
      role="switch"
      aria-checked={enabled}
      onClick={toggle}
      className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 ${
        enabled ? 'bg-primary-600' : 'bg-gray-300'
      }`}
    >
      <span className="sr-only">{label}</span>
      <span
        className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${
          enabled ? 'translate-x-5' : 'translate-x-0.5'
        }`}
      />
    </button>
  );
};

export default LearningModeSwitch;
